
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import VuePagination from 'laravel-vue-pagination';

@Component({
    components: {
        VuePagination
    }
})
export default class AppButton extends Vue {
    @Prop({  default: 5 }) pageLimit!: boolean;
    @Prop({ default: true }) showDisabled!: boolean;
    @Prop() data!: object;

}
